interface DeductionUserProps {
    userId: number | null;
    fullName: string;
    avatar: string | null;
    isDeleted: boolean;
}

export class DeductionUser {
    private readonly _userId: number | null;
    private readonly _fullName: string;
    private readonly _avatar: string | null;
    private readonly _isDeleted: boolean;

    constructor(props: DeductionUserProps) {
        this._userId = props.userId;
        this._fullName = props.fullName;
        this._avatar = props.avatar;
        this._isDeleted = props.isDeleted;
    }

    get userId(): number | null {
        return this._userId;
    }

    get fullName(): string {
        return this._fullName;
    }

    get avatar(): string | null {
        return this._avatar;
    }

    get isDeleted(): boolean {
        return this._isDeleted;
    }
}

export type { DeductionUserProps }